<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container>
            <v-card>
                <v-card-text>
                    <v-layout>
                        <v-flex>
                            <h1>Delivery</h1>
                        </v-flex>
                        <v-flex text-xs-right>
                            <v-btn flat :disabled="detail.length < 1" @click="printDeliveryForm" color="red" dark>
                                <v-icon>print</v-icon>
                                Print delivery form
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <!-- <v-btn @click="test">test</v-btn> -->
                    <hr>
                    <v-layout justify-end>
                        <v-flex xs2 text-xs-right>
                            <v-text-field label="Delivery no:" v-model="dnNo" readonly  tabindex="-1"></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout justify-end>
                        <v-flex xs2>
                            <v-menu v-model="menuDate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition"
                            offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="date" label="Date:" prepend-icon="event" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="date" @input="menuDate = false"></v-date-picker>
                            </v-menu>
                        </v-flex>
                    </v-layout>
                    <v-layout justify-end>
                        <v-flex xs2 text-xs-right>
                            <v-text-field label="Invocie no:" v-model="invNo" readonly  tabindex="-1"></v-text-field>
                        </v-flex>
                    </v-layout>

                    <!-- Header order detail -->
                    <v-layout pt-2 pb-2 indigo lighten-4>
                        <v-flex xs1 ml-1 mr-2><strong>No</strong></v-flex>
                        <v-flex xs3 mr-3><strong>Model</strong></v-flex>
                        <v-flex xs1 mr-2 pr-1 text-xs-center><strong>Frame</strong></v-flex>
                        <v-flex xs1 mr-2 text-xs-center><strong>Front</strong></v-flex>
                        <v-flex xs3 mr-3><strong>Quality control</strong></v-flex>
                        <!-- <v-flex xs2 mr-2 text-xs-right><strong>Amount</strong></v-flex> -->
                        <v-flex xs2></v-flex>
                    </v-layout>
                    <hr>
                    <v-layout wrap v-for="(item,i) in detail" :key="i" collapse>
                        <v-flex xs1 ml-1 mr-2>
                            <v-text-field :value="i+1" readonly></v-text-field>
                        </v-flex>
                        <v-flex xs3 mr-2>
                            <v-text-field v-model="item.Code" readonly></v-text-field>
                        </v-flex>
                        <v-flex xs1 mr-2 v-if="!item.subProd">
                            <v-select :items="itemFrame" v-model="item.frame" ref="frame"></v-select>
                        </v-flex>
                        <v-flex xs1 mr-2 v-if="!item.subProd">
                            <v-select :items="itemFront" v-model="item.front" ref="front"></v-select>
                        </v-flex>
                        <v-flex xs3 mr-2 v-if="!item.subProd">
                            <v-autocomplete :items="item.itemQC" v-model="item.qc" ref="qc" @change="onChangeQC(item)"
                            :color="!item.qc ? 'red' : 'primary'"></v-autocomplete>
                        </v-flex>
                        <v-flex>
                            <v-btn fab small color="primary" @click="addSubProd(i)" tabindex="-1"
                            v-if="!item.subProd || item.subProd.length == 0">
                                <v-icon dark>add</v-icon>
                            </v-btn>
                            <v-btn :disabled="detail.length == 1" fab small color="error" @click="delProd(item)" tabindex="-1">
                                <v-icon dark>remove</v-icon>
                            </v-btn>
                        </v-flex>
                        <v-layout v-for="(item,j) in item.subProd" :key="j">
                            <v-flex xs1 ml-1 mr-2></v-flex>
                            <v-flex xs3 mr-2>
                                <v-text-field v-model="item.subCode" @input="uppercase(item,i,j)"
                                @keypress.enter="getProdCode(item,i,j)"
                                :readonly="j != detail[i].subProd.length - 1" ref="subCode"></v-text-field>
                            </v-flex>
                            <v-flex xs1 mr-2>
                                <v-select :items="itemFrame" v-model="item.frame" @change="getQc(item)" ref="frame"></v-select>
                            </v-flex>
                            <v-flex xs1 mr-2>
                                <v-select :items="itemFront" v-model="item.front" @change="getQc(item)" ref="front"></v-select>
                            </v-flex>
                            <v-flex xs3 mr-2>
                                <v-autocomplete :items="item.itemQC" v-model="item.qc" ref="qc" @change="onChangeQC(item)"
                                :color="!item.qc ? 'red' : 'primary'"></v-autocomplete>
                            </v-flex>
                            <v-flex>
                                <v-btn fab small color="primary" @click="addSubCode(i)" 
                                :disabled="item.subCode == '' || !item.qc || j != detail[i].subProd.length - 1">
                                    <v-icon dark>add</v-icon>
                                </v-btn>
                                <v-btn fab small color="error" @click="delSubCode(item,i)" tabindex="-1">
                                    <v-icon dark>remove</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-layout>
                    <hr>
                    <br>

                    <!-- Show dialog products -->
                    <v-dialog v-model="dialogProd" max-width="500px">
                        <v-data-table :headers="headerProd" :items="prodDetail">
                            <template v-slot:items="props">
                                <tr @click="selectProdCode(props.item)">
                                    <td>{{props.item.Code}}</td>
                                    <td>{{props.item.NameMM}}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-dialog>
                    <!-- Button save and cancel -->
                    <v-layout align-center column>
                        <v-flex>
                            <v-btn @click="addDelivery">
                                <v-icon dark>save</v-icon>
                                Save
                            </v-btn>
                            <v-btn @click="cancelDelivery">
                                <v-icon dark>clear</v-icon>
                                Cancel
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-container>

        <!-- Dialog progress -->
        <v-dialog v-model="showDialog" max-width="90" persistent>
            <div class="text-xs-center">
                <v-card>
                    <v-card-text>
                        <v-progress-circular v-if="showProgress" :size="30" color="primary" indeterminate></v-progress-circular>
                        <div v-if="showSuccess">
                            <v-icon color="green" :size="40">check_circle_outline</v-icon>
                            Success.
                        </div>
                    </v-card-text>
                </v-card>
            </div>
        </v-dialog>
    </v-app>
</template>
<script>
import {db} from '@/firebase'
import mainMenu from '@/components/mainMenu.vue'
export default {
    components:{
        mainMenu
    },
    data(){
        return{
            showDialog: false,
            showProgress: false,
            showSuccess: false,
            invNo: this.$route.query.invNo,
            dnNo: '',
            idInv: '',
            menuDate: false,
            date: new Date().toISOString().substr(0,10),
            detail: [],
            dialogProd: false,
            headerProd:[
                { text: 'Product code', value: 'Code' },
                { text: 'Product name', sortable: false, },
            ],
            checkCode: '',

            prodDetail: [],
            posiProd: 0,
            posiProdCode: 0,

            itemFrame: [],
            itemFront: [],
            itemQC: [],
            itemColorQC: [],
        }
    },
    methods:{
        test(){
            // let arr = [
            //     { Code: "SGD-3K", frame: "DG", front: "BO" },
            //     { Code: "WD-05-2KPT/SP(S)", frame: "PP", front: "OR" },
            //     { Code: "PT-04(S)", frame: "BM", front: "G1" },
            // ]
            // db.collection("invoice").add({
            //     invNo: "Z190001",
            //     detail: arr,
            // })
            // .then(()=>{
            //     console.log("Success.")
            // })

            // db.collection("stock").add({
            //     puNo: "PU190001",
            //     date: "2019-11-21",
            //     itemCode: "WD-05-2KP/SP/D",
            //     frame: "PP",
            //     front: "OR",
            //     qc: "R6D5S6D3X5",
            //     amt: 2000,
            //     dnNo: '',
            //     dnDate: ''
            // })
            // .then(()=>{
            //     console.log("Success.")
            // })
        },
        testDuplicate(){
            let arr = [3,5,3,9,8,3,9,8,4,4,1,2,3,1,1,2]
            let newArr = []
            arr.forEach(rec=>{
                let i = newArr.findIndex(get=>get == rec)
                if(i == -1){
                    newArr.push(rec)
                }
            })
            console.log(arr)
            console.log(newArr)
        },

        uppercase(item,i,j){
            this.detail[i].subProd[j].subCode = this.detail[i].subProd[j].subCode.toUpperCase()
            item.frame = ''
            item.front = ''
        },

        // Get delivery no
        getDnNo(){
            let year = new Date().toISOString().substr(0,4)
            let subYear = year.substr(2,2)
            db.collection("counter").doc(year).get()
            .then(doc=>{
                let typeDoc = doc.data().dn + 1
                if (typeDoc<=9999){ 
                    typeDoc = ("000"+typeDoc).slice(-4)
                }
                this.dnNo = "DN" + subYear + typeDoc
            })
        },

        // Show products that need to be shipped
        getProd() {
            let app = this
            this.detail = []
            db.collection("invoice").where("invNo", "==", this.invNo).get()
            .then(query=>{
                let data = []
                let arrCode = []
                this.idInv = query.docs[0].id
                query.forEach(doc => {
                    doc.data().detail.forEach(rec=>{
                        if(rec.numSend < rec.num){
                            rec.num = rec.num - rec.numSend
                            data.push(rec)
                        }
                    })
                })
                data.forEach(rec=>{
                    if(rec.num > 1){
                        for (let i = 0; i < rec.num; i++) {
                            arrCode.push(rec)
                        }
                    }
                    else{
                        arrCode.push(rec)
                    }
                })
                let i = 0
                arrCode.forEach(rec=>{
                    let subProd = []
                    db.collection("code").doc("productcode").collection("proCode").where("Code", "==", rec.Code).get()
                        .then(query => {
                        query.forEach(doc=>{
                            if(doc.data().subProd == undefined){
                                app.detail.push({ Code: doc.data().Code, defuFrame: rec.frame, defuFront: rec.front, 
                                    frame: rec.frame, front: rec.front, itemQC: []
                                })
                            }
                            else{
                                doc.data().subProd.forEach(rec=>{
                                    subProd.push({ subCode: rec.subCode, itemQC: [] })
                                })
                                app.detail.push({ Code: doc.data().Code, defuFrame: rec.frame, defuFront: rec.front,
                                    // frame: rec.frame, front: rec.front, subProd: subProd
                                    frame: rec.frame, front: rec.front, itemQC: []
                                })
                            }
                        })
                        i++
                        callback()
                    })

                })
                let callback = function
                    callback() {
                    if(arrCode.length === i){
                        app.itemColorQC = []
                        app.detail.forEach(rec=>{
                            if(rec.subProd){
                                rec.subProd.forEach(ob=>{
                                    db.collection("stock").where("itemCode", "==", ob.subCode).where("dnNo", "==", "").get()
                                    .then(query=>{
                                        let id = 0
                                        query.forEach(doc=>{
                                            app.itemColorQC.push({ id: query.docs[id].id, qc: doc.data().qc, 
                                            frame: doc.data().frame, front: doc.data().front, amt: doc.data().amt })
                                            ob.itemQC.push(doc.data().qc)
                                            id++
                                        })
                                    })
                                })
                            }
                            else{
                                db.collection("stock").where("itemCode", "==", rec.Code).where("dnNo", "==", "").get()
                                .then(query=>{
                                    let id = 0
                                    query.forEach(doc=>{
                                        app.itemColorQC.push({ id: query.docs[id].id, qc: doc.data().qc,
                                        frame: doc.data().frame, front: doc.data().front, amt: doc.data().amt })
                                        rec.itemQC.push(doc.data().qc)
                                        id++
                                    })
                                })
                            }
                        })

                        let color = app.itemColorQC
                        color.sort((a, b) => a.qc.localeCompare(b.qc))
                        let id = null
                        let qc = null
                        let frame = null
                        let front = null
                        let amt = 0
                        let count = 0
                        let newColor = []
                        for (let i = 0; i < color.length; i++) {
                            let dup = color[i]
                            if(dup.qc != qc){
                                if(count > 0){
                                    newColor.push({ id: id, qc: qc, frame: frame, front: front, amt: amt })
                                }
                                id = dup.id
                                qc = dup.qc
                                frame = dup.frame
                                front = dup.front
                                amt = dup.amt
                                count = 1
                            }
                            else{
                                count++
                            }
                        }
                        if(count > 0){
                            newColor.push({ id: id, qc: qc, frame: frame, front: front, amt: amt })
                        }
                        app.itemColorQC = []
                        app.itemColorQC = newColor
                    }
                }
            })
        },

        onChangeQC(item) {
            let i = this.itemColorQC.findIndex(rec => item.qc == rec.qc)
            item.frame = this.itemColorQC[i].frame
            item.front = this.itemColorQC[i].front
            item.id = this.itemColorQC[i].id
            item.amt = this.itemColorQC[i].amt
        },

        // Get Frame and Front from database
        getFrameFront(){
            this.itemFrame = []
            this.itemFront = []
            db.collection("code").doc("color").get()
            .then(doc=>{
                doc.data().frame.forEach(rec=>{
                    this.itemFrame.push(rec)
                })
                doc.data().front.forEach(rec=>{
                    this.itemFront.push(rec)
                })
            })
        },

        // Add sub product
        addSubProd(i){
            let arr = this.detail
            this.detail = []
            let j = 0
            arr.forEach(rec=>{
                if(j == i){
                    this.detail.push({ Code: rec.Code, frame: rec.frame, front: rec.front, subProd: [{ subCode: '' }] })
                }
                else{
                    if(rec.subProd){
                        this.detail.push({ Code: rec.Code, frame: rec.frame, front: rec.front, subProd: rec.subProd })
                    }
                    else{
                        this.detail.push({ Code: rec.Code, frame: rec.frame, front: rec.front, itemQC: rec.itemQC })
                    }
                }
                j++
            })
        },

        // Add new sub code
        addSubCode(i){
            this.detail[i].subProd.push({ subCode: '' })
        },

        // Delete sub code
        delSubCode(item,i){
            if(this.detail[i].subProd.length == 1){
                db.collection("code").doc("productcode").collection("proCode").where("Code", "==", this.detail[i].Code).get()
                .then(query=>{
                    let checkSubProd = []
                    query.forEach(doc=>{
                        checkSubProd = doc.data().subProd
                    })
                    if(checkSubProd == undefined){
                        let app = this
                        app.detail[i].subProd.splice(app.detail[i].subProd.findIndex(rec=>rec == item),1)
                        delete app.detail[i].subProd
                        let clone = app.detail
                        db.collection("stock").where("itemCode", "==", this.detail[i].Code).where("dnNo", "==", "").get()
                        .then(query=>{
                            let itemQC = []
                            query.forEach(doc=>{
                                itemQC.push(doc.data().qc)
                            })
                            clone.forEach(rec=>{
                                if(!rec.subProd){
                                    rec.defuFrame = rec.frame
                                    rec.defuFront = rec.front
                                    rec.itemQC = itemQC
                                }
                            })
                            app.detail = []
                            app.detail = clone
                        })
                    }
                })
            }
            else{
                this.detail[i].subProd.splice(this.detail[i].subProd.findIndex(rec=>rec == item),1)
            }
        },

        // Find product code
        getProdCode(item,i,j){
            db.collection("code").doc("productcode").collection("proCode").orderBy("Code").startAt(item.subCode).endAt(item.subCode + "\uf8ff").get()
            .then(query=>{
                this.prodDetail = []
                query.forEach(doc=>{
                    this.prodDetail.push(doc.data())
                })
                if(this.prodDetail.length > 0){
                    this.dialogProd = true
                    this.posiProd = i
                    this.posiProdCode = j
                }
            })
        },

        // Select product code
        selectProdCode(item){
            this.detail[this.posiProd].subProd[this.posiProdCode].subCode = item.Code
            this.dialogProd = false
            this.checkCode = item.Code
            // this.getQc(item)
        },

        // 
        getQc(item){
            if(item.subCode != '' && item.frame && item.front){
                let app = this
                db.collection("stock").where("itemCode", "==", item.subCode).where("frame", "==", item.frame)
                .where("front", "==", item.front).where("dnNo", "==", "").get()
                .then(query=>{
                    let i = 0
                    let itemQc = []
                    query.forEach(doc=>{
                        app.itemColorQC.push({ id: query.docs[i].id, qc: doc.data().qc,
                        frame: doc.data().frame, front: doc.data().front, amt: doc.data().amt })
                        itemQc.push(doc.data().qc)
                        i++
                    })

                    app.itemColorQC.sort((a, b) => a.qc.localeCompare(b.qc))
                    let id = null
                    let qc = null
                    let frame = null
                    let front = null
                    let amt = 0
                    let count = 0
                    let newArr = []
                    for (let i = 0; i < app.itemColorQC.length; i++) {
                        let result = app.itemColorQC[i]
                        if(result.qc != qc){
                            if(count > 0){
                                newArr.push({ id: id, qc: qc, frame: frame, front: front, amt: amt })
                            }
                            id = result.id
                            qc = result.qc
                            frame = result.frame
                            front = result.front
                            amt = result.amt
                            count = 1
                        }
                        else{
                            count++
                        }
                    }
                    if(count > 0){
                        newArr.push({ id: id, qc: qc, frame: frame, front: front, amt: amt })
                    }
                    app.itemColorQC = []
                    app.itemColorQC = newArr

                    let clone = app.detail

                    clone.forEach(rec=>{
                        if(rec.subProd){
                            rec.subProd.forEach(prod=>{
                                if(prod.subCode == item.subCode){
                                    if(!prod.itemQC){
                                        let dup = app.itemColorQC.filter(fil=>prod.frame == fil.frame && prod.front)
                                        let data = []
                                        dup.forEach(qc=>{
                                            data.push(qc.qc)
                                        })
                                        prod.itemQC = data
                                    }
                                    else{
                                        if(prod.itemQC.length == 0){
                                            let dup = app.itemColorQC.filter(fil=>prod.frame == fil.frame && prod.front)
                                            let data = []
                                            dup.forEach(qc=>{
                                                data.push(qc.qc)
                                            })
                                            prod.itemQC = data
                                        }
                                    }
                                }
                            })
                        }
                    })
                    app.detail = []
                    app.detail = clone
                })
            }
        },

        // Delete items don't want to send
        delProd(item){
            this.detail.splice(this.detail.findIndex(rec=>rec == item),1)
        },

        // Add items to send
        addDelivery(){
            let app = this
            let arrNull = []
            for (let i = 0; i < app.detail.length; i++) {
                let data = app.detail[i]
                for (let l = 0; l < app.$refs.qc.length; l++) {
                    if(data.subProd){
                        for (let j = 0; j < data.subProd.length; j++) {
                            let data2 = data.subProd[j]
                            if(!data2.qc){
                                if(app.$refs.qc[l].initialValue == null){
                                    this.$refs.qc[l].focus()
                                    arrNull.push(data2.subCode)
                                }
                            }
                        }
                    }
                    else{
                        if(!data.qc){
                            if(app.$refs.qc[l].initialValue == null){
                                this.$refs.qc[l].focus()
                                arrNull.push(data.subCode)
                            }
                        }
                    }
                }
            }
            if(arrNull.length == 0){
                this.showDialog = true
                this.showProgress = true
                this.detail.forEach(rec=>{
                    if(rec.subProd){
                        rec.subProd.forEach(obj=>{
                            delete obj.itemQC
                        })
                    }
                    else{
                        delete rec.itemQC
                    }
                })
                let arrCode = null
                let defuFrame = null
                let defuFront = null
                let frame = null
                let front = null
                let count = 0
                let arrCount = []
                for (let i = 0; i < app.detail.length; i++) {
                    if(app.detail[i].Code != arrCode){
                        if(count > 0){
                            arrCount.push({ Code: arrCode, defuFrame: defuFrame, defuFront: defuFront, frame: frame, front: front, num: count })
                        }
                        arrCode = app.detail[i].Code
                        defuFrame = app.detail[i].defuFrame
                        defuFront = app.detail[i].defuFront
                        frame = app.detail[i].frame
                        front = app.detail[i].front
                        count = 1
                    }
                    else{
                        count++
                    }
                }
                if(count > 0){
                    arrCount.push({ Code: arrCode, defuFrame: defuFrame, defuFront: defuFront, frame: frame, front: front, num: count })
                }                let docInv = db.collection("invoice").doc(app.idInv)
                db.runTransaction(transaction=>{
                    return transaction.get(docInv).then(Doc=>{
                        if (!Doc.exists) {
                            throw "Document does not exist!"
                        }
                        let newInvDetail = Doc.data().detail
                        arrCount.forEach(rec=>{
                            let newPos = newInvDetail.findIndex(detail=>detail.Code == rec.Code && detail.frame == rec.defuFrame && 
                            detail.front == rec.defuFront)
                            newInvDetail[newPos].numSend += rec.num
                        })
                        transaction.update(docInv,{
                            detail: newInvDetail
                        })
                    })
                })
                .then(()=>{
                    // let year = "2018"
                    let year = new Date().toISOString().substr(0,4)
                    let subYear = year.substr(2,2)
                    db.collection("counter").doc(year).get()
                    .then(doc=>{
                        let typeDoc = doc.data().dn + 1
                        if (typeDoc<=9999){ 
                            typeDoc = ("000"+typeDoc).slice(-4)
                        }
                        app.dnNo = "DN" + subYear + typeDoc
                        let DocRef = db.collection("counter").doc(year)
                        db.runTransaction((transaction)=>{
                            return transaction.get(DocRef).then((Doc)=>{
                                if (!Doc.exists) {
                                    throw "Document does not exist!"
                                }
                                else{
                                    let newGl = Doc.data().dn + 1
                                    transaction.update(DocRef, {
                                        dn: newGl
                                    })
                                }
                            })
                        })
                        .then(()=>{
                            let i = 0
                            let amt = 0
                            app.detail.forEach(rec=>{
                                if(rec.subProd){
                                    rec.subProd.forEach(item=>{
                                        if(item.amt){
                                            amt += item.amt
                                        }
                                        db.collection("stock").doc(item.id).update({
                                            invNo: app.invNo,
                                            dnNo: app.dnNo,
                                            dnDate: app.date,
                                            status: 'Closed'
                                        })
                                        .then(()=>{
                                            i++
                                            callback()
                                        })
                                    })
                                }
                                else{
                                    amt += rec.amt
                                    db.collection("stock").doc(rec.id).update({
                                        invNo: app.invNo,
                                        dnNo: app.dnNo,
                                        dnDate: app.date,
                                        status: 'Closed'
                                    })
                                    .then(()=>{
                                        i++
                                        callback()
                                    })
                                }
                            })
                            let callback = function
                            callback(){
                                if(app.detail.length === i){
                                    db.collection("generalLedger").add({
                                        glNo: app.dnNo,
                                        refNo: app.invNo,
                                        glDate: app.date,
                                        desc: "Delivery",
                                        accId: "500101",
                                        accName: "Cost of Goods Sold",
                                        debit: amt,
                                        credit: 0,
                                        remark: "",
                                    })
                                    .then(()=>{
                                        db.collection("generalLedger").add({
                                            glNo: app.dnNo,
                                            refNo: app.invNo,
                                            glDate: app.date,
                                            desc: "Delivery",
                                            accId: "113301",
                                            accName: "Finished Goods",
                                            debit: 0,
                                            credit: amt,
                                            remark: "",
                                        })
                                        .then(()=>{
                                            app.checkStatusInv()
                                        })
                                    })
                                }
                            }
                        })
                    })
                })
            }
        },

        // Check the invoice. If all the products have been delivered, close them
        checkStatusInv(){
            db.collection("invoice").doc(this.idInv).get()
            .then(query=>{
                let newOrderDetail = query.data().detail
                let detailCheck = []
                newOrderDetail.forEach(item=>{
                    if(item.numSend < item.num){
                        item.num = item.num - item.numSend
                        detailCheck.push(item)
                    }
                })
                if(detailCheck.length == 0){
                    db.collection("invoice").doc(this.idInv).update({
                        status: "Closed"
                    })
                }
            })
            .then(()=>{
                this.showDialog = true
                this.showProgress = false
                this.showSuccess = true
                setTimeout(() => {
                    this.showDialog = false
                    this.showProgress = false
                    this.showSuccess = false
                    let routeData = this.$router.resolve({ name: 'invStatus' })
                    window.location.assign(routeData.href)
                }, 2000)
            })
        },

        // Cancel delivery
        cancelDelivery(){
            this.getDnNo()
            this.getProd()
        },

        // Print delivery form
        printDeliveryForm(){
            let routeData = this.$router.resolve({ name: 'printFormDelivery', query: {
                invNo: this.invNo,
                date: this.date,
                detail: JSON.stringify(this.detail)
            }})
            window.open(routeData.href)
        }
    },
    mounted(){
        this.getDnNo()
        this.getProd()
        this.getFrameFront()
    }
}
</script>
<style scoped>
.collapse:nth-child(even){
    background-color: #dddddd;
}
table {
  border-collapse: collapse;
  width: 100%;
}

th, td {
  /* text-align: left; */
  padding: 0.5%;
  /* padding: 10px; */
}
.line{
    border-bottom: 1px solid gray;
    text-align: right;
    width: 100%;
}
</style>